<div class="policy-category disabled">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <radio-question [data]="permitType.data" [valueSelected]="permitType.valueSelected"
                    (selectAnswer)="onPermitTypeSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <radio-question [data]="reconsider.data" [active]="permitType.valueSelected !== '1'"
                    [valueSelected]="reconsider.valueSelected"
                    (selectAnswer)="onReconsiderSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">3</i>
    <select-question [data]="failDisplay.data" [active]="permitType.valueSelected !== '1' && reconsider.valueSelected !== 'n'"
                     [valueSelected]="failDisplay.valueSelected"
                     (selectAnswer)="onFailDisplaySelected($event)"></select-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">4</i>
    <radio-question [data]="cancel.data" [active]="permitType.valueSelected !== '1'"
                    [valueSelected]="cancel.valueSelected"
                    (selectAnswer)="onCancelSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">5</i>
    <div class="default-text large" [innerHTML]="textCopy.virtualPermitsTitle"></div>
    <multiple-select-question [data]="virtualPermits.data" [active]="permitType.valueSelected !== '0'"
                              [valuesSelected]="virtualPermits.valuesSelected"
                              (selectAnswer)="onVirtualPermitsSelected($event)"></multiple-select-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">6</i>
    <explain-question [data]="explain.data" [valueSelected]="explain.valueSelected"
                      [validationSelected]="explain.validationSelected"
                      [active]="explain.active"
                      [validationText]="explain.validationText"
                      (selectAnswer)="onExplainSelected($event)"></explain-question>
  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
